
export const apiRoutes = {
  GET_PROPOSITION: '/api/v1/object/list',
  SEARCH: '/api/v1/object/search',
  GET_TYPES: '/api/v1/types',
  GET_BEACHES: '/api/v1/beaches',
  GET_OPTIONS: '/api/v1/options',
  REQUEST: '/api/v1/request'
};
